import React from "react";
//#region types
import { TagsProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import { Chip, Grid } from "@mui/material";
import SimpleTooltip from "./tooltips/tooltip";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Tags: React.FC<TagsProps> = (props) => {
  const hasMoreItems = props.maxDisplayCount && props.tags.length > props.maxDisplayCount;
  const surfaceClassName = props.surface === "background" ? cssExports.tagSurfaceBackground : undefined;
  return (
    <Grid item className={cssExports.tagContainer}>
      <Grid item container direction="row" wrap="nowrap" spacing={1}>
        <Grid item className={clsx(cssExports.tagContainerInner, hasMoreItems ? cssExports.withMoreItems : "")}>
          <Grid item container spacing={1}>
            {props.tags
              .slice(0, props.maxDisplayCount ? props.maxDisplayCount : props.tags.length)
              .map((tag, index) => (
                <SimpleTooltip key={`tag-${index}`} text={props.toolTips?.length ? props.toolTips[index] : undefined}>
                  <Grid item xs>
                    <Chip
                      label={tag}
                      className={clsx(cssExports.tag, props.className ?? cssExports.blueTag, surfaceClassName)}
                    />
                  </Grid>
                </SimpleTooltip>
              ))}
          </Grid>
        </Grid>
        {hasMoreItems && (
          <SimpleTooltip text={props.tags.slice(props.maxDisplayCount, props.tags.length).join(", ")}>
            <Grid item className={cssExports.moreItemsTagContainer}>
              <Chip
                label={`+${props.tags.length - (props.maxDisplayCount ?? 0)}`}
                className={clsx(cssExports.tag, props.className ?? cssExports.blueTag, surfaceClassName)}
              />
            </Grid>
          </SimpleTooltip>
        )}
      </Grid>
    </Grid>
  );
};

export default Tags;
